module.exports = __webpack_public_path__ + "e01b9f66cdbb15264c302832723654ce.jpg";